export const validObject = (object) => !!object && Object.keys(object).length > 0;
